export default __webpack_public_path__ + "static/media/7.24adcd0e.jpeg";